// extracted by mini-css-extract-plugin
export default {"root":"xvIZKr6Z","wrapperText":"tClgJpHe","wrapperShortText":"tNrqnnHd","avatarsLine":"CYSVh_bt","scroll":"mDgZ9SN4"};